// FAQ Accordion functionality
// Uses event delegation to handle multiple FAQ sections on the same page
(function() {
  'use strict';
  
  // Use a flag to ensure we only bind once
  if (window.faqInitialized) {
    return;
  }
  window.faqInitialized = true;

  // Single event delegation on document for all FAQ sections
  $(document).on('click', '.faq-container .accordion', function(e) {
    e.preventDefault();
    
    // Get the clicked accordion button
    var $accordion = $(this);
    
    // Find the corresponding panel (next sibling)
    var $panel = $accordion.next('.panel');
    
    // Toggle the active class on the clicked accordion
    $accordion.toggleClass('active');
    
    // Slide toggle the panel (show/hide with animation)
    $panel.slideToggle('fast');
  });
})();
